import {Response} from '..'
import {RequestError} from './RequestError'

export default function throwIfNotSuccess<T extends Response>(
  resp: T,
  upperCutoff = 400
): T {
  if (resp.statusCode < 200 || resp.statusCode >= upperCutoff) {
    throw new RequestError(resp)
  }
  return resp
}
